import apiClient from './apiClient';

export interface Employee {
  id: string;
  email: string;
  fullName: string;
}

export interface EmployeeWithRole extends Employee {
  roleId?: string;
  roleName?: string;
}

export interface AssignRoleDto {
  employeeId: number;
  roleId: string;
}

export interface EmployeeSearchResult {
  id: number;
  employeeName: string;
  email: string;
}

export const employeeService = {
  async searchEmployees(query: string): Promise<EmployeeSearchResult[]> {
    const response = await apiClient.get(`/api/employees/search?q=${encodeURIComponent(query)}`);
    const employees = Array.isArray(response.data) ? response.data : [];
    return employees.map((emp: EmployeeWithRole) => ({
      id: Number(emp.id),
      employeeName: emp.fullName,
      email: emp.email,
    }));
  },

  async getEmployeeById(id: string): Promise<EmployeeWithRole> {
    const response = await apiClient.get(`/api/employees/${id}`);
    return response.data;
  },

  async getEmployeeIdByEmail(email: string): Promise<string> {
    const response = await apiClient.get(`/api/employees/by-email/${encodeURIComponent(email)}`);
    return response.data;
  },

  async assignRole(employeeId: string, roleId: string): Promise<void> {
    const dto: AssignRoleDto = {
      employeeId: parseInt(employeeId, 10),
      roleId
    };
    await apiClient.post(`/api/employees/${employeeId}/role`, dto);
  },

  async getPrivilegedEmployees(): Promise<EmployeeWithRole[]> {
    const response = await apiClient.get('/api/employees/privileged');
    return response.data;
  },

  async removeRole(employeeId: string): Promise<void> {
    await apiClient.delete(`/api/employees/${employeeId}/role`);
  },
};

export default employeeService;
